<template>
  <PrimeSelectButton
    v-model="value"
    :options="options"
    ref="boolSelectButton"
    @change="changeEventHandler($event)"
    @blur="blurEventHandler($event)"
    @input="inputEventHandler($event)"
    v-bind="$attrs"
    :disabled="loading || disabled"
    optionValue="value"
    optionLabel="label"
  >
  </PrimeSelectButton>
</template>

<script setup lang="ts">
import {
  type IInputEvent,
  type IChangeEvent,
  type IBlurEvent,
} from "~/scad-shared/types/interfaces";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inputType?: string;
    error?: string;
    loading?: boolean;
    id?: string;
    enabledLabel?: string;
    disabledLabel?: string;
    affectFields?: string[];
    dataKey?: string;
  }>(),
  {
    enabledLabel: "Yes",
    disabledLabel: "No",
    disabled: false,
    loading: false,
    affectFields: () => [],
    dataKey: Math.random().toString().substring(2, 20),
  }
);

const form = defineModel<any>("form");

function setAffectedValues(value: boolean) {
  props.affectFields.forEach((valueKey: string) => {
    const keys = valueKey.split("@");
    const from = keys[0];
    const to = keys.length > 1 ? keys[1] : from;
    if (from.charAt(0) == "#") {
      // Set to value in form to static string
      form.value[to] = from.slice(1);
    } else if (from.charAt(0) == "$") {
      // Set to value in form to static number
      form.value[to] = Number(from.slice(1));
    } else if (from.includes("?")) {
      // Set to value in form to value depending on expression
      // TODO: Implement
    } else if (from.charAt(0) == "!") {
      form.value[to] = value;
    } else {
      form.value[to] = !value;
    }
  });
}

const value = defineModel<any>("value");
const options = ref([
  { value: true, label: props.enabledLabel },
  { value: false, label: props.disabledLabel },
]);

const emits = defineEmits<{
  change: [event: IInputEvent];
  input: [event: IChangeEvent];
  blur: [event: IBlurEvent];
}>();

watch(
  () => value,
  (newValue) => {
    // console.log(newValue);
  }
);

function changeEventHandler($event: any) {
  setAffectedValues(value.value);
  emits("change", { ...$event, value: value.value });
}
function inputEventHandler($event: any) {
  emits("input", { ...$event, value: value.value });
}
function blurEventHandler($event: any) {
  emits("blur", { ...$event, value: value.value });
}
</script>

<style scoped></style>
